
import PdfImageGrade1 from "../../assets/backgrounds/ficha-grade-1.webp";
import PdfImageGrade2 from "../../assets/backgrounds/ficha-grade-2.webp";
import PdfImageGrade3 from "../../assets/backgrounds/ficha-grade-3.webp";
import PdfImageGrade4 from "../../assets/backgrounds/ficha-grade-4.webp";
import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import "./LoginCarousel.scss";


function LoginCarousel() {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    return (
        <Carousel className="LoginCarousel" activeIndex={index} onSelect={handleSelect} interval={9000} indicatorLabels={true}>
            <Carousel.Item aria-label="1" >
                <img
                    className="d-block w-100 mb-3"
                    src={PdfImageGrade1}
                    alt="1"
                />
                <p className="text-caption text-end mb-0"> Pagina 1</p>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={PdfImageGrade2}
                    alt="2"
                />
                <p className="text-caption text-end mb-0"> Pagina 2</p>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={PdfImageGrade3}
                    alt="3"
                />
                <p className="text-caption text-end mb-0"> Pagina 3</p>
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src={PdfImageGrade4}
                    alt="4"
                />
                <p className="text-caption text-end mb-0"> Pagina 4</p>
            </Carousel.Item>
        </Carousel>

    );
}

export default LoginCarousel;